export function Right(value) {
    return [null, value];
}
export function Left(error) {
    return [error, null];
}
//# sourceMappingURL=either.js.map